// This function is replacing underscores with spaces
export const formatCustomFieldLabel = (label) => {
  if (!label) return '';
  return label.replace(/_/g, ' ');
};
